/**
 * sets all nested objs within roleTranslation
 * @param {object} roleTranslation global page var
 * @returns {object} roleTranslation
 */
export function setRoleTranslation(roleTranslation) {
    roleTranslation.class = {
        singular: `team`,
        plural: `teams`,
    };
    roleTranslation.instructor = {
        singular: `leader`,
        plural: `leaders`,
    };
    roleTranslation.student = {
        singular: `member`,
        plural: `members`,
    };
    roleTranslation.classmate = {
        singular: `teammate`,
        plural: `teammates`,
    };
    roleTranslation.assignment = {
        singular: `task`,
        plural: `tasks`,
    };

    return roleTranslation;
}

/**
 * sets all nested objects within rankThemes
 * @param {object} rankThemes global rankThemes var
 * @returns {object} rankThemes
 */
export function setRankThemes(rankThemes) {
    // svgs
    rankThemes.crest = {
        // basic crest outline
        1: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" xml:space="preserve">
                <g style="stroke:none;stroke-width:0;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:none;fill-rule:nonzero;opacity:1">
                    <path 
                        d="M45 89.998a8.2 8.2 0 0 1-2.559-.41C22.855 83.082 10.2 67.552 10.2 50.022V18.234a5.61 5.61 0 0 1 4.603-5.529c10.332-1.879 19.341-5.76 26.775-11.534a5.58 5.58 0 0 1 6.843 0c7.435 5.774 16.442 9.655 26.775 11.534a5.61 5.61 0 0 1 4.602 5.529v31.788c0 17.53-12.654 33.061-32.238 39.566a8.2 8.2 0 0 1-2.56.41M15.519 16.641a1.61 1.61 0 0 0-1.318 1.593v31.788c0 15.776 11.58 29.817 29.5 35.77.837.279 1.76.277 2.6 0 17.919-5.952 29.498-19.993 29.498-35.77V18.234c0-.784-.555-1.455-1.318-1.593-10.972-1.996-20.564-6.138-28.512-12.31a1.58 1.58 0 0 0-1.937 0c-7.948 6.172-17.541 10.314-28.513 12.31" 
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:currentColor;fill-rule:nonzero;opacity:1"
                        transform="translate(1.407 1.407)scale(2.81)"
                    />
                </g>
            </svg>`, // svg code for all level 1 crests (type: string)
        
        // crest with inner highlights
        2: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" xml:space="preserve">
                <g style="stroke:none;stroke-width:0;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:none;fill-rule:nonzero;opacity:1">
                    <path 
                        d="M45 89.998a8.2 8.2 0 0 1-2.559-.41C22.855 83.082 10.2 67.552 10.2 50.022V18.234a5.61 5.61 0 0 1 4.603-5.529c10.332-1.879 19.341-5.76 26.775-11.534a5.58 5.58 0 0 1 6.843 0c7.435 5.774 16.442 9.655 26.775 11.534a5.61 5.61 0 0 1 4.602 5.529v31.788c0 17.53-12.654 33.061-32.238 39.566a8.2 8.2 0 0 1-2.56.41M15.519 16.641a1.61 1.61 0 0 0-1.318 1.593v31.788c0 15.776 11.58 29.817 29.5 35.77.837.279 1.76.277 2.6 0 17.919-5.952 29.498-19.993 29.498-35.77V18.234c0-.784-.555-1.455-1.318-1.593-10.972-1.996-20.564-6.138-28.512-12.31a1.58 1.58 0 0 0-1.937 0c-7.948 6.172-17.541 10.314-28.513 12.31" 
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:currentColor;fill-rule:nonzero;opacity:1"
                        transform="translate(1.407 1.407)scale(2.81)"
                    />
                    <path 
                        d="M46.465 79.562a2.002 2.002 0 0 1-.63-3.899 39 39 0 0 0 5.305-2.204c10.5-5.313 16.768-14.472 16.768-24.501a2 2 0 0 1 4 0c0 11.568-7.088 22.063-18.96 28.069a43 43 0 0 1-5.852 2.433q-.316.102-.631.102M20.093 35.323a2 2 0 0 1-2-2v-8.505a4.74 4.74 0 0 1 3.889-4.672c4.857-.883 9.342-2.354 13.33-4.37a2 2 0 1 1 1.805 3.569c-4.332 2.191-9.183 3.784-14.418 4.736a.744.744 0 0 0-.605.736v8.505a2 2 0 0 1-2.001 2.001m49.814 7.041a2 2 0 0 1-2-2V27.051a2 2 0 0 1 4 0v13.313a2 2 0 0 1-2 2m-49.814 5.403a2 2 0 0 1-2-2v-5.22a2 2 0 0 1 4 0v5.22a2 2 0 0 1-2 2" 
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:currentColor;fill-rule:nonzero;opacity:1"
                        transform="translate(1.407 1.407)scale(2.81)"
                    />
                </g>
            </svg>`, // svg code for all level 2 crests (type: string)
            
        // crest with inner highlights and crown (look for: REPLACETHIS)
        3: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" xml:space="preserve">
                <g style="stroke:none;stroke-width:0;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:none;fill-rule:nonzero;opacity:1">
                    <path 
                        d="M45 89.998a8.2 8.2 0 0 1-2.559-.41C22.855 83.082 10.2 67.552 10.2 50.022V18.234a5.61 5.61 0 0 1 4.603-5.529c10.332-1.879 19.341-5.76 26.775-11.534a5.58 5.58 0 0 1 6.843 0c7.435 5.774 16.442 9.655 26.775 11.534a5.61 5.61 0 0 1 4.602 5.529v31.788c0 17.53-12.654 33.061-32.238 39.566a8.2 8.2 0 0 1-2.56.41M15.519 16.641a1.61 1.61 0 0 0-1.318 1.593v31.788c0 15.776 11.58 29.817 29.5 35.77.837.279 1.76.277 2.6 0 17.919-5.952 29.498-19.993 29.498-35.77V18.234c0-.784-.555-1.455-1.318-1.593-10.972-1.996-20.564-6.138-28.512-12.31a1.58 1.58 0 0 0-1.937 0c-7.948 6.172-17.541 10.314-28.513 12.31" 
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:currentColor;fill-rule:nonzero;opacity:1"
                        transform="translate(1.407 1.407)scale(2.81)"
                    />
                    <path 
                        d="M46.465 79.562a2.002 2.002 0 0 1-.63-3.899 39 39 0 0 0 5.305-2.204c10.5-5.313 16.768-14.472 16.768-24.501a2 2 0 0 1 4 0c0 11.568-7.088 22.063-18.96 28.069a43 43 0 0 1-5.852 2.433q-.316.102-.631.102M20.093 35.323a2 2 0 0 1-2-2v-8.505a4.74 4.74 0 0 1 3.889-4.672c4.857-.883 9.342-2.354 13.33-4.37a2 2 0 1 1 1.805 3.569c-4.332 2.191-9.183 3.784-14.418 4.736a.744.744 0 0 0-.605.736v8.505a2 2 0 0 1-2.001 2.001m49.814 7.041a2 2 0 0 1-2-2V27.051a2 2 0 0 1 4 0v13.313a2 2 0 0 1-2 2m-49.814 5.403a2 2 0 0 1-2-2v-5.22a2 2 0 0 1 4 0v5.22a2 2 0 0 1-2 2" 
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:currentColor;fill-rule:nonzero;opacity:1"
                        transform="translate(1.407 1.407)scale(2.81)"
                    />
                    <path 
                        d="M474.25,193.656c-20.859,0-37.766,16.906-37.766,37.75c0,14.078,7.797,26.203,19.203,32.703 c-5.594,19.203-16.5,39.156-34.031,49.141c-35.063,19.906-66.703-11.859-48.219-97.75c18.078-2.813,31.969-18.313,31.969-37.188 c0-20.844-16.906-37.75-37.766-37.75s-37.75,16.906-37.75,37.75c0,13.469,7.109,25.219,17.703,31.891 c-10.063,49.516-25.453,69.281-44.406,66.688c-28.328-3.859-32.656-42.203-32.797-113.219 c13.703-5.672,23.359-19.141,23.359-34.875c0-20.859-16.906-37.766-37.75-37.766s-37.75,16.906-37.75,37.766 c0,15.75,9.656,29.219,23.375,34.875c-0.156,71.016-4.5,109.359-32.813,113.219c-18.969,2.594-34.359-17.172-44.406-66.688 c10.594-6.688,17.703-18.422,17.703-31.891c0-20.844-16.906-37.75-37.766-37.75c-20.844,0-37.75,16.906-37.75,37.75 c0,18.875,13.891,34.391,31.969,37.188c18.484,85.891-13.156,117.656-48.219,97.75c-17.531-9.984-28.438-29.938-34.031-49.156 c11.406-6.484,19.188-18.609,19.188-32.688c0-20.844-16.906-37.75-37.75-37.75S0,210.563,0,231.406 C0,250.438,14.125,266,32.406,268.625l26.281,152.344H256h197.313l26.281-152.344C497.875,266,512,250.438,512,231.406 C512,210.563,495.094,193.656,474.25,193.656z"
                        style="stroke:none;stroke-width:1;stroke-dasharray:none;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;fill:REPLACETHIS;fill-rule:nonzero;opacity:1" 
                        transform="translate(51 -8)scale(.3, .12)"
                    />
                </g>
            </svg>`, // svg code for all level 3 crests (type: string)
    };

    // names
    rankThemes.names = {
        1: `Fogged`, // rank 1 name (type: string, default: Fogged)
        2: `Focused`, // rank 2 name (type: string, default: Focused)
        3: `Insightful`, // rank 3 name (type: string, default: Insightful)
        4: `Illuminated`, // rank 4 name (type: string, default: Illuminated)
        5: `Visionary`, // rank 5 name (type: string, default: Visionary)
    };

    // colors
    rankThemes.colors = {
        1: {
            highlight: `#c7c9cb`, // hex color for theme: silver (type: string)
            contrast: `#000000`, // hex color for contrast to theme (type: string)
            className: `silver`, // rank div class name (type: string)
        },
        2: {
            highlight: `#edb611`, // hex color for theme: gold (type: string)
            contrast: `#000000`, // hex color for contrast to theme (type: string)
            className: `gold`, // rank div class name (type: string)
        },
        3: {
            highlight: `#00f492`, // hex color for theme: emerald (type: string)
            contrast: `#000000`, // hex color for contrast to theme (type: string)
            className: `emerald`, // rank div class name (type: string)
        },
        4: {
            highlight: `#ad41fa`, // hex color for theme: purple (type: string)
            contrast: `#ffffff`, // hex color for contrast to theme (type: string)
            className: `purple`, // rank div class name (type: string)
        },
        5: {
            highlight: `#4cd5e1`, // hex color for theme: turqoise (type: string)
            contrast: `#000000`, // hex color for contrast to theme (type: string)
            className: `turqoise`, // rank div class name (type: string)
        },
    };

    return rankThemes;
}